import ReportsAddressTableHeader from './ReportsAddressTableHeader'

export default ReportsAddressTableHeader
